import { useEffect, useState } from 'react';
import { useViewClaimList } from 'all-in-one-shared-api';

import { useKeycloakReady } from 'hooks';

import { NewClaimUtils } from '../utils/newClaimUtils';
import { SelectedClaimTypeObjectType } from './useSelectedClaimTypeMapping';

interface UsePreviousClaimsProps {
  patientMemberType: string;
  selectedClaimTypeObject: SelectedClaimTypeObjectType;
  step: number;
  pageIndex: number;
  pageSize: number;
}

export const usePreviousClaims = ({
  patientMemberType,
  selectedClaimTypeObject,
  step,
  pageIndex,
  pageSize,
}: UsePreviousClaimsProps) => {
  const { ready, token } = useKeycloakReady();
  const [page, setPage] = useState(pageIndex);

  const {
    data,
    shouldFetch: viewClaimShouldFetch,
    mutate,
  } = useViewClaimList(
    'useViewClaimList',
    token ?? '',
    NewClaimUtils.mapViewClaimFilter(patientMemberType, selectedClaimTypeObject),
    {
      revalidateOnFocus: false,
    },
  );

  useEffect(() => {
    if (selectedClaimTypeObject.data.length > 0) {
      viewClaimShouldFetch(ready && step === 0);
      mutate();
    } else {
      viewClaimShouldFetch(false);
    }
  }, [selectedClaimTypeObject.data.length, ready, step, viewClaimShouldFetch, mutate]);

  const indexStart = (page - 1) * pageSize;
  const indexEnd = indexStart + pageSize;
  return {
    isHavePreviousClaim: !!data?.results.length,
    previousClaims: data?.results.slice(indexStart, indexEnd),
    previousClaimsCount: data?.totalCount ?? 0,
    page,
    setPage,
  };
};
